import { render, staticRenderFns } from "./NaturezaTab.vue?vue&type=template&id=9866cd1e"
import script from "./NaturezaTab.vue?vue&type=script&lang=js"
export * from "./NaturezaTab.vue?vue&type=script&lang=js"
import style0 from "./NaturezaTab.vue?vue&type=style&index=0&id=9866cd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports